(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ag-autumn-card"] && !Shopify.designMode) return;
  try {
    (function(){
  const parts=['h3','.ag-live-card__benefit','.ag-autumn-card__offer','.ag-live-card__reviews'];
  let pending=false;
  function align(){
    pending=false;
    document.querySelectorAll('.ag-live-products__grid').forEach(grid=>{
      const cards=Array.from(grid.querySelectorAll('.ag-autumn-card'));
      cards.forEach(card=>parts.forEach(sel=>{const el=card.querySelector(sel);if(el)el.style.minHeight='';}));
      const rows=new Map();
      cards.forEach(card=>{const y=Math.round(card.offsetTop);if(!rows.has(y))rows.set(y,[]);rows.get(y).push(card);});
      rows.forEach(row=>parts.forEach(sel=>{
        const elements=row.map(card=>card.querySelector(sel)).filter(Boolean);
        const height=Math.ceil(Math.max(0,...elements.map(el=>el.getBoundingClientRect().height)));
        elements.forEach(el=>el.style.minHeight=height+'px');
      }));
    });
  }
  function schedule(){if(!pending){pending=true;requestAnimationFrame(align);}}
  window.addEventListener('resize',schedule);
  window.addEventListener('load',schedule);
  document.addEventListener('shopify:section:load',schedule);
  if(document.fonts)document.fonts.ready.then(schedule);
  schedule();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ag-autumn-product-offer"] && !Shopify.designMode) return;
  try {
    function initAutumnPickers() {
    document.querySelectorAll('[data-autumn-picker]').forEach(picker => {
      if (picker.dataset.ready) return;
      picker.dataset.ready = 'true';
      const form = picker.closest('form');
      if (!form) return;
      const selectedId = form.querySelector('[name="id"]');
      let quantity = form.querySelector('[name="quantity"]');
      if (!quantity) { quantity = document.createElement('input'); quantity.type='hidden'; quantity.name='quantity'; quantity.value='1'; form.appendChild(quantity); }
      function update() {
        const plan = form.querySelector('[name="selling_plan"]');
        picker.hidden = String(form.querySelector('select[name="id"]')?.value || form.querySelector('input[name="id"]')?.value) !== picker.dataset.variant || Boolean(plan?.value);
        if (picker.hidden) { picker.querySelector('input[value="1"]').checked=true; }
        else { picker.querySelectorAll('input[type="radio"]').forEach(radio => { radio.checked = radio.value === quantity.value; }); }
      }
      picker.addEventListener('change', event => {
        if (event.target.type !== 'radio') return;
        quantity.value=event.target.value;
        quantity.dispatchEvent(new Event('change',{bubbles:true}));
      });
      form.addEventListener('change', () => { setTimeout(update,0); });
      document.addEventListener('variant:change',update);
      form.addEventListener('click',()=>setTimeout(update,100));
      if (window.jQuery) window.jQuery(form).on('variantChange',update);
      new MutationObserver(()=>setTimeout(update,0)).observe(form,{childList:true,subtree:true});
      const planInput=form.querySelector('[name="selling_plan"]');
      if(planInput) new MutationObserver(update).observe(planInput,{attributes:true});
      if (selectedId) new MutationObserver(update).observe(selectedId,{attributes:true,childList:true,subtree:true});
      update();
    });
  }
  initAutumnPickers();
  document.addEventListener('shopify:section:load',initAutumnPickers);
  } catch(e) { console.error(e); }
})();

})();
